import members from './members'
import expert from './expert'
import tutor from './tutor'
import recommender from './recommender'
import enfriends from './enfriends'
import whoareat from './whoareat'

export const config = {
  members: members,
  expert: expert,
  tutor: tutor,
  recommender: recommender,
  whoareat: whoareat,
  enfriends: enfriends
}


// WEBPACK FOOTER //
// ./src/mock/index.js